import { gql } from '@apollo/client';

export const crashReportRowFragment = gql`
  fragment CrashReportRow on CrashReport {
    id
    trigger
    capturedAt
    receivedAt
    legacyServerId
    legacyServerNumber
    exitCode
    fileName
    size
    sha256
    server {
      id
      name
      owner {
        id
        name
      }
    }
    version {
      id
      versionString
    }
    legacyServerVersion {
      id
      version
    }
  }
`;

export const crashReportsQuery = gql`
  query CrashReports(
    $where: CrashReportFilterInput
    $order: [CrashReportSortInput!]
  ) {
    crashReports(where: $where, order: $order) {
      ...CrashReportRow
    }
  }
  ${crashReportRowFragment}
`;

export const crashReportQuery = gql`
  query CrashReport($id: UUID!) {
    crashReport(id: $id) {
      ...CrashReportRow
      files {
        path
        size
        compressedSize
      }
    }
  }
  ${crashReportRowFragment}
`;

export const legacyServerVersionsQuery = gql`
  query CrashReportLegacyServerVersions(
    $order: [LegacyServerVersionSortInput!]
  ) {
    legacyServerVersions(order: $order) {
      id
      version
    }
  }
`;

export const crashReportOwnersQuery = gql`
  query CrashReportOwners($order: [OwnerSortInput!]) {
    owners(order: $order) {
      id
      name
    }
  }
`;

export const crashReportDeleteMutation = gql`
  mutation CrashReportDelete($id: UUID!) {
    crashReportDelete(id: $id)
  }
`;
